/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Link } from 'gatsby';
import type { FC } from 'react';

import DevlogPreview from './devlog-preview';
import { usePosts } from './hooks/use-posts';
import { rhythm } from './styles/typography';

const Devlog: FC = () => {
  const posts = usePosts();

  return (
    <section>
      <h2>Devlog</h2>

      <div
        css={css`
          margin: ${rhythm(1.5)} 0 ${rhythm(2)};
        `}
      >
        {posts.map((v) => (
          <DevlogPreview key={v.slug} post={v} />
        ))}

        {posts.length < 3 ? null : (
          <div
            css={css`
              display: flex;
              justify-content: center;
              padding: ${rhythm(0.7)} ${rhythm(1)};
            `}
          >
            <Link
              css={css`
                color: hsla(0, 0%, 0%, 0.63);
                font-family: 'Recursive', sans-serif;
                text-decoration-color: hsla(0, 0%, 0%, 0.53);
                user-select: none;
              `}
              to="/devlog"
            >
              <strong>More &rarr;</strong>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Devlog;
